export enum DailyPausePageTestId {
    Container = 'DailyPausePageTestId.Container',
    DoneButton = 'DailyPausePageTestId.DoneButton',
    SkeletonLoader = 'DailyPausePageTestId.SkeletonLoader',
}

export enum DailyPauseCelebrationTestId {
    Container = 'DailyPauseCelebrationTestId.Container',
}

export enum DailyPauseAdditionalOptionsTestId {
    Container = 'DailyPauseAdditionalOptionsTestId.Container',
}

export enum DailyPauseStatsTestId {
    Container = 'DailyPauseStatsTestId.Container',
}

export enum DailyPauseFeedbackTestId {
    Container = 'DailyPauseFeedbackTestId.Container',
}
